import React, { useState } from "react";
import { useEffectOnce } from "react-use";
import Typography from "../../Unknown/Typography";
import getDeadlineMinutes from "./getDeadlineMinutes";
import useFormattedValue from "./useFormattedValue";

const timerUpdateInterval = 1000;

interface ReportDeliveryDeadlineCountdownProps {
  startedAtCenterTimezone: Date;
  readyToReadAtCenterTimezone: Date;
  reportDeliveryDeadlineHours: number;
  isStat: boolean;
  timezone: string;
}

const ReportDeliveryDeadlineCountdown: React.FC<
  ReportDeliveryDeadlineCountdownProps
> = ({
  startedAtCenterTimezone,
  readyToReadAtCenterTimezone,
  reportDeliveryDeadlineHours,
  isStat,
  timezone,
}) => {
  const [minutesLeft, setMinutesLeft] = useState<number | null>(null);

  useEffectOnce(() => {
    const updateCountdown = () => {
      const deadlineMinutes = getDeadlineMinutes({
        timezone,
        startedAtCenterTimezone,
        readyToReadAtCenterTimezone,
        reportDeliveryDeadlineHours,
        isStat,
      });

      setMinutesLeft(Math.max(deadlineMinutes, 0));
    };

    updateCountdown();

    const interval = setInterval(updateCountdown, timerUpdateInterval);

    return () => {
      clearInterval(interval);
    };
  });

  const formattedValue = useFormattedValue(minutesLeft);

  return (
    <Typography
      variant="subtitle2"
      fontSize={11}
      lineHeight={1.2}
      textAlign="center"
      color="text.secondary"
    >
      {formattedValue}
    </Typography>
  );
};

export default ReportDeliveryDeadlineCountdown;
